import { render } from "./CameraCapture.vue?vue&type=template&id=a5314114&scoped=true"
import script from "./CameraCapture.vue?vue&type=script&lang=js"
export * from "./CameraCapture.vue?vue&type=script&lang=js"

import "./CameraCapture.vue?vue&type=style&index=0&id=a5314114&scoped=true&lang=css"

import exportComponent from "../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5314114"]])

export default __exports__